import { Grid, Typography } from '@material-ui/core';
import { FormControl, FormLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getIdleTime, setIdleTime } from '../../../services/admin/settings/systemSettings.service';
import { CancelButton } from '../../buttons/CancelButton.component';
import { ConfirmButton } from '../../buttons/ConfirmButton.component';
import { LeavePrompt } from '../../Prompt/LeavePrompt/LeavePrompt.component';
import { TextFieldOne } from '../../TextFieldOne/TextFieldOne.component';
import { useStyles } from '../SystemSettings.styles';
import { useLayoutContext } from '../../../Context/Layout.context';

const MIN_TIME = 10;
const MAX_TIME = 999;
export const isTimeWrongError =
  'Wprowadzona wartość jest nieprawidłowa. Prawidłowa wartość powinna mieścić się w zakresie liczb 10-999';

export const ActivityTime: React.FC<{
  onClose: () => void;
  onChange: () => void;
}> = ({ onClose, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);
  const [time, setTime] = useState<string>();
  const [timeFromResponse, setTimeFromResponse] = useState<string>();
  const { openAlert,  setIsLoader} = useLayoutContext();
  const [isDisable, setIsDisable] = useState(false)

  useEffect(() => {
    setIsLoader(true);
    getIdleTime()
      .then((result) => {
        setTime(result ? (result as number).toString() : undefined);
        setTimeFromResponse(result ? (result as number).toString() : undefined);
      })
      .catch(() => setTime(undefined))
      .finally(()=>setIsLoader(false))
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTime(event.target.value);
    setIsDisable(false);
  };

  const isTimeWrong: boolean = (time !== undefined && +time < MIN_TIME) || (time !== undefined && +time > MAX_TIME);
  const isDataChanged: boolean = timeFromResponse !== time;

  const handleOnSave = () => {
    setIsLoader(true)
    setIdleTime(time !== undefined ? +time : 10)
      .then(() => {
        openAlert('success');
        
      })
      .catch(() => openAlert('error'))
      .finally(()=>{setIsLoader(false);setIsDisable(true);})
  };

  const handleOnClose = () => {
    if (isDataChanged) {
      setIsLeavePromptOpen(true);
    } else onClose();
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.listHeader}>
            <Typography className={classes.tabTitle}>{t('systemSettings:activeTime.header')}</Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <FormControl
            focused={false}
            sx={{
              marginTop: -1,
              '& .MuiFormLabel-root': {
                fontWeight: 700,
                fontSize: 14,
              },
            }}
            component="fieldset"
            variant="standard"
          >
            <FormLabel sx={{ color: '#2C2D3E', margin: '10px 0px 10px 0px' }} component="legend">
              Czas bezczynności użytkownika w systemie (wartość wyrażona w minutach od 10-999)
            </FormLabel>
            <TextFieldOne
              area-label="Wartość"
              name="activityLength"
              required
              data-testid="activityLength"
              label="Wartość"
              defaultValue={time}
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              value={time}
              error={isTimeWrong}
              helperText={isTimeWrong ? isTimeWrongError : undefined}
              sx={{
                width: 120,
                fontSize: 10,
                marginTop: 1,
                '& .MuiFormHelperText-root': {
                  width: 380,
                  marginLeft: -0.3,
                },
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs={12} style={{ position: 'absolute', right: '20px', bottom: '20px' }}>
          <CancelButton onClick={handleOnClose}>Anuluj</CancelButton>
          <ConfirmButton onClick={handleOnSave} disabled={isDisable || !time || isTimeWrong || !isDataChanged }>
            Zapisz
          </ConfirmButton>
        </Grid>
      </Grid>
      <LeavePrompt isOpen={isLeavePromptOpen} onConfirm={onClose} onCancel={() => setIsLeavePromptOpen(false)} />
    </>
  );
};
